import { Box, Typography } from "@material-ui/core";
import React from "react";
import clsx from "clsx";
import {
  RECOMMENDED_FLIGHT_LIST_SEPARATOR_PRIMARY_TEXT,
  RECOMMENDED_FLIGHT_LIST_SEPARATOR_SECONDARY_TEXT,
} from "../FlightListInfo/textConstants";
import { FlightListInfo, IFlightListInfoProps } from "../FlightListInfo";

export interface RecommendedFlightInfoProps
  extends Omit<
    IFlightListInfoProps,
    | "flight"
    | "flights"
    | "slice"
    | "index"
    | "isRecommendedFlight"
    | "showListView"
  > {
  flight: any;
  flights: any;
}

export const RecommendedFlightInfo = ({
  flight,
  flights,
  selectedFare,
  selectedFareId,
  expandedFlight,
  fareClassFilter,
  maxPriceFilter,
  isOutgoing,
  packageNightCountBasedOnAvailability,
  packageNightCountBasedOnOutboundFlight,
  packagesByOutboundFareSlice,
  packagesByReturnFareSlice,
  departureDate,
  returnDate,
  hotelShopDateRange,
  isTripDetailsLoading,
  airports,
  rewardsKey,
  isAgentPortal,
  expandedFareDetails,
  isXmodRedesign,
  handleClickAlgomerchTag,
  setOpenModal,
  handleSliceSelect,
  setClickedFareId,
  setExpandedFlight,
  handleFareSelect,
  selectedRewardsAccount,
  canEarnRewards,
}: RecommendedFlightInfoProps) => {
  if (!flight) {
    return null;
  }
  const flightSliceId = flight.slice;
  const flightSlice = flights?.slices[flightSliceId];
  if (!flightSlice) {
    return null;
  }

  return (
    <>
      <FlightListInfo
        showListView
        slice={flightSlice}
        flight={flight}
        index={0}
        isRecommendedFlight
        flights={flights}
        selectedFare={selectedFare}
        selectedFareId={selectedFareId}
        expandedFlight={expandedFlight}
        fareClassFilter={fareClassFilter}
        maxPriceFilter={maxPriceFilter}
        isOutgoing={isOutgoing}
        packageNightCountBasedOnAvailability={
          packageNightCountBasedOnAvailability
        }
        packageNightCountBasedOnOutboundFlight={
          packageNightCountBasedOnOutboundFlight
        }
        packagesByOutboundFareSlice={packagesByOutboundFareSlice}
        packagesByReturnFareSlice={packagesByReturnFareSlice}
        departureDate={departureDate}
        returnDate={returnDate}
        hotelShopDateRange={hotelShopDateRange}
        isTripDetailsLoading={isTripDetailsLoading}
        airports={airports}
        rewardsKey={rewardsKey}
        isAgentPortal={isAgentPortal}
        selectedRewardsAccount={selectedRewardsAccount}
        canEarnRewards={canEarnRewards}
        expandedFareDetails={expandedFareDetails}
        handleClickAlgomerchTag={handleClickAlgomerchTag}
        setOpenModal={setOpenModal}
        handleSliceSelect={handleSliceSelect}
        setClickedFareId={setClickedFareId}
        setExpandedFlight={setExpandedFlight}
        handleFareSelect={handleFareSelect}
        isXmodRedesign={isXmodRedesign}
      />
      {/* TODO: Move this to components, make common */}
      <Box className={clsx("recommended-flight-list-separator")}>
        <Box className="recommended-flight-list-separator-top-row">
          <Box className="dashed-line" />
          <Typography className="recommended-flight-list-separator-primary-text">
            {RECOMMENDED_FLIGHT_LIST_SEPARATOR_PRIMARY_TEXT}
          </Typography>
          <Box className="dashed-line" />
        </Box>
        <Typography className="recommended-flight-list-separator-secondary-text">
          {RECOMMENDED_FLIGHT_LIST_SEPARATOR_SECONDARY_TEXT}
        </Typography>
      </Box>
    </>
  );
};
